import { useQuery } from "@tanstack/react-query";
import { engineError } from "@/lib/engine-error";
import type { TechnologyEnvelope } from "@/lib/profitability-api";

/**
 * Profitability by the platform a demand is tagged with.
 *
 * Thirteen rows including the untagged group, so no paging and no server-side
 * sort -- the whole set arrives at once and the columns sort in the browser,
 * the same arrangement the Client Partner board uses for the same reason.
 */
export function useTechnology(range?: string) {
  return useQuery({
    queryKey: ["technology", range ?? "default"],
    queryFn: async (): Promise<TechnologyEnvelope> => {
      const params = new URLSearchParams();
      if (range) params.set("range", range);
      const qs = params.toString();
      const response = await fetch(`/api/technology${qs ? `?${qs}` : ""}`);
      if (!response.ok) {
        throw await engineError(response, "Could not load technology profitability");
      }
      return response.json();
    },
    staleTime: 5 * 60 * 1000,
  });
}
